<template>
    <div class="w3-container">
        <p class="title w3-center">
            Top-Web<br>
            Dynamic DNS Manager
        </p>

        <div v-show="action !== ''" class="login-action w3-center">
            {{ action }} ...
        </div>

        <div v-show="action === ''" class="login-box w3-padding">
            <div v-show="step === 'credentials'">
                <p>{{ $t('Please sign in to manage your dynamic DNS settings using the form below') }}:</p>
                <p><input class="w3-input" :placeholder="$t('Username')" v-model="username" @keyup="handleFormKeyUp($event)"></p>
                <p><input class="w3-input" type="password" :placeholder="$t('Password')" v-model="password" @keyup="handleFormKeyUp($event)"></p>
                <p class="w3-right-align">
                    <a :href="lostPasswordUrl" target="_blank" class="w3-button">
                        {{ $t('I have forgotten my password') }}
                    </a>&nbsp;
                    <button class="w3-button" @click="signIn()">{{ $t('Sign in') }}</button>
                </p>
            </div>
            
            <div v-show="step === 'twofa'">
                <p>{{ $t('Please enter the current one time password') }}:</p>
                <p><input class="w3-input" :placeholder="$t('One Time Password')" v-model="otp" @keyup="handleFormKeyUp($event)"></p>
                <p class="w3-right-align">
                    <button class="w3-button" @click="reset()">{{ $t('Cancel') }}</button>&nbsp;
                    <button class="w3-button" @click="checkOtp()">{{ $t('Continue') }}</button>
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped>
.title {
    font-size: 3em;
}

.login-action {
    font-size: 1.5em;
}

.login-box {
    width: 80%;
    margin: auto;
}
</style>

<script>
import Api from 'Api'
import Store from '@/utils/Store'

import User from '@/model/User'
import Session from '../model/Session'

export default {
    data () {
        return {
            step: 'credentials',
            action: '',

            username: '',
            password: '',

            otp: ''
        }
    },

    computed: {
        lostPasswordUrl: () => `${Api.ISPCP_URL}/login/password_reset.php`
    },

    methods: {
        signIn () {
            let self = this

            if (self.username === '') {
                window.toast({ text: self.$i18n.t('Plase enter a user name.'), color: 'yellow' })
                return
            }
            if (self.password === '') {
                window.toast({ text: self.$i18n.t('Please enter a password.'), color: 'yellow' })
                return
            }

            self.action = self.$i18n.t('Signing in ...')
            Api.postAuthLogin(self.username, btoa(self.password))
                .then(resp => {
                    if (typeof resp.data.user !== 'object' ||
                            typeof resp.data['2fa'] !== 'boolean' ||
                            typeof resp.data.sessionid !== 'string') {
                        window.toast({ text: self.$i18n.t('Invalid API response.'), color: 'red' })
                        throw new Error('Invalid API response.')
                    }

                    const user = User.fromObject(resp.data.user)
                    // const session = new Session(resp.data.sessionid, user)
                    const session = new Session(resp.data.sessionid, user);
                    Store.commit('session', session)
                    session.persist()

                    if (resp.data['2fa']) {
                        self.step = 'twofa'
                    } else {
                        self.reset()
                        self.$router.push('/')
                    }
                })
                .catch((err) => {
                    self.action = ''
                    console.log(err)
                    window.toast({ text: self.$i18n.t('Failed to sign in.'), color: 'red' })
                })
        },

        checkOtp () {
            let self = this

            if (self.otp === '') {
                window.toast({ text: self.$i18n.t('Please enter a one time password.'), color: 'yellow' })
                return
            }

            self.action = self.$i18n.t('Checking one time password')
            Api.postAuthCheckTwoFa(btoa(self.otp))
                .then(resp => {
                    if (typeof resp.data.usedRescueCode === 'boolean' && resp.data.usedRescueCode) {
                        window.toast({
                            text: self.$i18n.t('You have used a rescue code. 2FA has been disabled.'),
                            timeout: 0
                        })
                    }
                    self.reset()
                    self.$router.push('/')
                })
                .catch(err => {
                    window.toast({
                        text: self.$i18n.t('The entered one time password or rescue code were not valid or 2FA is not enabled.'),
                        color: 'red'
                    })
                    self.action = ''
                    self.otp = ''
                })
        },

        handleFormKeyUp (event) {
            if (typeof event.keyCode === 'number' && event.keyCode === 13) {
                switch (this.step) {
                case 'credentials':
                    this.signIn()
                    break

                case 'twofa':
                    this.checkOtp()
                    break
                }
            }
        },

        reset () {
            this.username = ''
            this.password = ''
            this.otp = ''
            this.action = ''
            this.step = 'credentials'
        }
    }
}
</script>

<i18n src="@/lang/common.json"></i18n>
<i18n src="@/lang/login.json"></i18n>
